import PropTypes from 'prop-types';
import { useSnackbar } from "notistack";
import { makeStyles } from '@material-ui/core/styles';
import React, { useState, useEffect, useRef } from "react";
import { Button, DialogActions, DialogContent } from "@material-ui/core";

import BasicInfo from './BasicInfo.js';
import CreatedBy from './CreatedBy.js';
import Usinas from './Usinas.js';
import api from "../../../../../services/api.js";

const useStyles = makeStyles((theme) => ({
    root: {
        '& .MuiTextField-root': {
            margin: theme.spacing(1),
            width: '25ch',
        },
    },
}));

export default function FormStore(props) {
    const classes = useStyles();

    const snack = useRef()
    const { enqueueSnackbar } = useSnackbar();
    snack.current = enqueueSnackbar

    const [values, setValues] = useState({
        _id: '',
        nome: '',
        email: '',
        cargo: '',
        admin: 'Não',
        celular: '',
        telefone: '',
        funcao: 'Supervisor da Usina',
        status: 'ativo',
        em_exercicio: 'Sim',

        criado_em: '',
        criado_por: '',
        editado_em: '',
        editado_por: '',
    });

    const [usinas, setUsinas] = React.useState({
    });


    const [update, setUpdate] = useState(false) // true in edit mode
    useEffect(() => {
        if (props.data) {
            let checked = {}
            for (let usina of props.list_usinas) {
                checked[usina._id] = false
            }
            for (let usina of props.data.usinas) {
                checked[usina._id] = true
            }
            setUsinas(checked);
            setValues(props.data)
            setUpdate(true)
        }
        else {
            let checked = {}
            for (let usina of props.list_usinas) {
                checked[usina._id] = false
            }
            setUsinas(checked)
        }
    }, [props])

    React.useEffect(() => { checkFields() });

    const [disable, setDisable] = useState(true)

    function checkFields() {
        //aqui testamos o e-mail
        let re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        let result = re.test(String(values.email).toLowerCase());
        let dis = true
        //verificações para habilitar SALVAR
        if (values.nome !== "" && values.email !== "" && result !== false) {
            dis = false
        }
        setDisable(dis);
    }

    async function AddNew() {
        snack.current("adicionando, aguarde.", { variant: 'info' })
        let my_usinas = []
        for (let key in usinas) {
            if (usinas[key]) {
                my_usinas.push(key)
            }
        }
        var new_user = {
            "nome": values.nome,
            "usinas": my_usinas,
            "cargo": values.cargo,
            "email": values.email,
            "admin": values.admin,
            "status": values.status,
            "funcao": values.funcao,
            "celular": values.celular,
            "telefone": values.telefone,
            "em_exercicio": values.em_exercicio,
        }
        api.post(`/user`, {
            new_user,
            url: document.URL.toString().split("users")[0]
        })
            .then(() => {
                props.setReload(currentIsOpen => !currentIsOpen)
                props.setOpen(false)
                snack.current(`usuário criado!`, { variant: 'success' })
            })
            .catch((error) => {
                if (error.response.data.message) {
                    snack.current(`${error.response.data.message}`, { variant: 'error' })
                } else {
                    snack.current("Falha ao adicionar usuário!", { variant: 'error' })
                }
            });
    }

    async function Update() {
        snack.current("editando, aguarde.", { variant: 'info' })
        let my_usinas = []
        for (let key in usinas) {
            if (usinas[key]) {
                my_usinas.push(key)
            }
        }
        var update_user = {
            "_id": values._id,
            "nome": values.nome,
            "usinas": my_usinas,
            "admin": values.admin,
            "cargo": values.cargo,
            "funcao": values.funcao,
            "status": values.status,
            "celular": values.celular,
            "telefone": values.telefone,
            "em_exercicio": values.em_exercicio,
        }
        api.put(`/user`, { update_user })
            .then(() => {
                props.setReload(currentIsOpen => !currentIsOpen)
                props.setOpen(false)
                snack.current("Usuário editado!", { variant: 'success' })
            })
            .catch((error) => {
                if (error.response.data.message) {
                    snack.current(`${error.response.data.message}`, { variant: 'error' })
                } else {
                    snack.current("Falha ao editar o usuário!", { variant: 'error' })
                }
            });
    }

    return (
        <>
            <DialogContent className={classes.root}>
                <div className="titles">Informações Gerais</div>
                <div className="row">
                    <div style={{ width: '80%' }}>
                        <BasicInfo values={values} setValues={setValues} update={update} />
                    </div>
                    <div style={{ width: '30%' }}>
                        <Usinas update={update} usinas={usinas} setUsinas={setUsinas} list_usinas={props.list_usinas} />
                    </div>
                </div>
                <CreatedBy values={values} setValues={setValues} />
            </DialogContent >
            <DialogActions>
                <Button
                    disabled={disable}
                    onClick={() => { update === true ? Update() : AddNew() }}
                >
                    Salvar
                </Button>
                <Button onClick={() => { props.setOpen(false) }}>
                    Cancelar
                </Button>
            </DialogActions>
        </>
    )
}

FormStore.propTypes = {
    setOpen: PropTypes.func,
    setReload: PropTypes.func
};
